import { motion } from "framer-motion";
import React, { useState } from "react";
import styled from "styled-components";
import { formatSelectOptionForAntd, pageAnimationConfig } from "../../../utils";
import { AntdSelect, Button, Text } from "../../atoms";
import { africredColors } from "../../../theme/colors";
import { brandTheme, screen } from "../../../theme";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useAuth from "../../../hooks/useAuth";
import { toast } from "react-toastify";

const Wrapper = styled(motion.div)``;
const WhiteArea = styled.div`
  display: flex;
  padding: 48px 12px;
  gap: px;
  border-radius: 32px;
  background: ${africredColors.neutrals.white[10]};
  margin-top: 28px;
  height: fit-content;
  justify-content: center;
  align-items: center;

  @media only screen and (${screen.md}) {
    padding: 48px;
  }
`;

export const PreferenceSettings = () => {
  const axiosPrivate = useAxiosPrivate();
  const auth = useAuth();
  const [preference, setPreference] = useState(auth?.personalPreference || {});
  const handleSubmit = async () => {
    try {
      const response = await axiosPrivate.patch(
        "/account/personal-preference-update",
        preference
      );
      if (response.data) {
        alert("Preference updated successfully");
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  return (
    <Wrapper {...pageAnimationConfig}>
      <Text type="h3" weight="medium">
        Personal preference
      </Text>
      <WhiteArea>
        <div className="flex flex-col gap-4 w-full sm:w-1/2 2xl:w-1/3">
          <Text type="h5" weight="medium">
            Default Currency
          </Text>
          <Text type="p">
            This will affect how price and amount will be displayed
          </Text>
          <AntdSelect
            options={formatSelectOptionForAntd(auth.enumValues?.currency)}
            defaultValue={preference?.currency}
            value={preference?.currency}
            setValue={(item) =>
              setPreference((prev) => ({ ...prev, currency: item }))
            }
          />

          <Text type="h5" weight="medium">
            My Time Zone
          </Text>
          <Text type="p">
            When dates are displayed, show them in this timezone.
          </Text>
          <AntdSelect
            options={formatSelectOptionForAntd(auth.enumValues?.timeZone)}
            defaultValue={preference?.timeZone}
            value={preference?.timeZone}
            setValue={(item) =>
              setPreference((prev) => ({ ...prev, timeZone: item }))
            }
          />

          <Text type="h5" weight="medium">
            My Date Format
          </Text>
          <Text type="p">
            When dates are displayed, show them in this format.
          </Text>

          <AntdSelect
            options={formatSelectOptionForAntd(auth.enumValues?.dateFormat)}
            defaultValue={preference?.dateFormat}
            value={preference?.dateFormat}
            setValue={(item) =>
              setPreference((prev) => ({ ...prev, dateFormat: item }))
            }
          />

          <Text type="h5" weight="medium">
            My Time Format
          </Text>
          <Text type="p">
            When times are displayed, show them in this format.
          </Text>

          <AntdSelect
            options={formatSelectOptionForAntd(auth.enumValues?.timeFormat)}
            defaultValue={preference?.timeFormat}
            value={preference?.timeFormat}
            setValue={(item) =>
              setPreference((prev) => ({ ...prev, timeFormat: item }))
            }
          />

          <Button
            onClick={handleSubmit}
            width="100%"
            size="md"
            bgcolor={brandTheme.brand.secondary}
            style={{ color: "white" }}
          >
            Update preference
          </Button>
        </div>
      </WhiteArea>
    </Wrapper>
  );
};
